import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetPartById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";

const ViewPart = () => {
  const navigate = useNavigate();
  let param = useParams();
  const part_id = param.p_id;
  const [formData, setFormData] = useState({
    part_number: "",
    company: "Select Company",
    description: "",
    category: "Select Category",
    sales_category: "Select Sales Category",
    unit: "Select Unit",
    location: "",
    cost_price: "0.0",
    sale_price: "0.0",
    markup: "0.0",
    status: "Select Status",
    serialized: false,
    image: { id: 1, file: null, preview: null },
    pn_note: "",
  });

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  useEffect(() => {
    async function fetchData() {
      if (part_id) {
        TimeoutUtility.resetTimeout();
        await GetPartById(part_id)
          .then((result) => {
            setFormData({
              part_number: result.data.part_number,
              company: {
                label: result.data.company,
                value: result.data.company_id,
              },
              description: result.data.description || "",
              category: {
                label: result.data.category,
                value: result.data.category_id,
              },
              sales_category: {
                label: result.data.s_category,
                value: result.data.s_category_id,
              },
              unit: { label: result.data.unit, value: result.data.unit_id },
              location: result.data.stockroom_location || "",
              cost_price: result.data.cost_price || "0.0",
              sale_price: result.data.sale_price || "0.0",
              markup: result.data.mark_up || "0.0",
              status: {
                label: result.data.pn_status,
                value: result.data.pn_status_id,
              },
              serialized: result.data.serialized,
              image: {
                id: 1,
                file: null,
                preview: "data:image/jpeg;base64," + result.data.image,
              },
              pn_note: result.data.pn_note || "",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW PART" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Part Number:"
                  name="part_number"
                  value={formData.part_number}
                  placeholder="Part Number"
                  disabled
                />
                <SelectField
                  label="Company:"
                  name="company"
                  value={formData.company}
                  placeholder="Company"
                  isDisabled
                />
                <TextAreaField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  placeholder="Part Description"
                  disabled
                />
                <SelectField
                  label="Category:"
                  name="category"
                  value={formData.category}
                  placeholder="Category"
                  isDisabled
                />
                <SelectField
                  label="Sales Category:"
                  name="sales_category"
                  value={formData.sales_category}
                  placeholder="Sales Category"
                  isDisabled
                />
                <SelectField
                  label="Unit:"
                  name="unit"
                  value={formData.unit}
                  placeholder="Unit"
                  isDisabled
                />
                <TextInputField
                  label="Stockroom Location:"
                  name="location"
                  value={formData.location}
                  placeholder="Stockroom Location"
                  disabled
                />
              </div>
            </Col>
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <DoubleField
                  label="Cost Price:"
                  name="cost_price"
                  value={formData.cost_price}
                  placeholder="Cost Price"
                  disabled
                />
                <DoubleField
                  label="Sale Price:"
                  name="sale_price"
                  value={formData.sale_price}
                  placeholder="Sale Price"
                  disabled
                />
                <DoubleField
                  label="Markup %:"
                  name="markup"
                  value={formData.markup}
                  placeholder="Markup"
                  disabled
                />
                <SelectField
                  label="PN Status:"
                  name="status"
                  value={formData.status}
                  placeholder="PN Status"
                  isDisabled
                />
                <div className="form-group mt-3">
                  <label className="label">Serialized:</label>
                  <input
                    type="checkbox"
                    className="input"
                    name="serialized"
                    disabled
                    checked={formData.serialized}
                  />
                </div>
                <TextAreaField
                  label="Notes:"
                  name="pn_note"
                  value={formData.pn_note}
                  placeholder="Part Notes"
                  disabled
                />
              </div>
            </Col>
            <Col md={4} className="container-col">
              <div className="col-lg-12 container-video-div">
                <div className="mt-10 w-100 flex flex-col">
                  {formData?.image?.preview && (
                    <img
                      src={formData?.image?.preview || null}
                      className="container-image"
                      alt={`Part ${formData?.image?.id}`}
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewPart;
